import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Panel,
  Col,
  Grid,
  Icon,
  PanelContainer,
  Row,
  Pagination,
  FormControl,
  // Button,
} from "@sketchpixy/rubix";
import { PatientActions } from "../reducers/patient/index";
import {
  INITIAL_PAGE_NUMBER,
  DEFAULT_TIME_FORMAT,
  DEFAULT_DATE_FORMAT,
  getScretSSN,
} from "../utils/index";
import * as _ from "lodash";
import moment from "moment";

import ExamResumeOrNew from "../components/ExamResumeOrNew";
import ExamEmailOrNew from "../components/ExamEmailOrNew";
import LoadingContainer from "../components/LoadingContainer";
import UnableToExamModal from "../components/UnableToExamModal";

class WidgetBlocks extends Component {
  constructor(props) {
    super(props);
    sessionStorage.removeItem("questionState");
    sessionStorage.removeItem("currentDbq");
    this.state = {
      startDate: props.startDate,
      searchText: undefined,
      patientSignedDbq: 0,
      showExamResumeOrNew: false,
      showExamEmailOrNew: false,
      loadingExam: false,
      questionsFromDb: [],
      dbqStatusInDb: "",
      dbqIsSigned: false,
      currentDbq: {},
      patient: {},
      showUnableToExam: false,
      appt: {},
      link: "",
      selected_row_index: null,
      diagnosesAndExtremitiesViewName: "",
    };

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.setDiagnosesAndExtremitiesRef =
      this.setDiagnosesAndExtremitiesRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleDiagnosesAndExtremitiesView =
      this.handleDiagnosesAndExtremitiesView.bind(this);
    this.handleClickOutsideDiagnosesAndExtremitiesRef =
      this.handleClickOutsideDiagnosesAndExtremitiesRef.bind(this);
    this.popoverRefs = new Map();
  }

  componentDidMount() {
    const startDate = this.props.startDate;
    this.props.getAllCampaignPatients(INITIAL_PAGE_NUMBER, startDate);
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideDiagnosesAndExtremitiesRef
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.startDate !== this.props.startDate) {
      const startDate = nextProps.startDate;
      this.props.getAllCampaignPatients(INITIAL_PAGE_NUMBER, startDate);
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener(
      "mousedown",
      this.handleClickOutsideDiagnosesAndExtremitiesRef
    );
    
    this.popoverRefs.clear();
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  setDiagnosesAndExtremitiesRef(node) {
    this.diagnosesAndExtremitiesRef = node;
  }

  setPopoverRef = (disabilityId, node) => {
    if (node) {
      this.popoverRefs.set(disabilityId, node);
    } else {
      this.popoverRefs.delete(disabilityId);
    }
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        selected_row_index: null,
      });
    }
  }

  handleClickOutsideDiagnosesAndExtremitiesRef(event) {
    if (
      this.diagnosesAndExtremitiesRef &&
      !this.diagnosesAndExtremitiesRef.contains(event.target) &&
      !event.target.id.includes("diagnosesAndExtremities-")
    ) {
      this.setState({ diagnosesAndExtremitiesViewName: "" });
    }
  }

  handleDiagnosesAndExtremitiesView(viewName) {
    if (this.state.diagnosesAndExtremitiesViewName === viewName) {
      this.setState({ diagnosesAndExtremitiesViewName: "" });
    } else {
      this.setState({ diagnosesAndExtremitiesViewName: viewName });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Reset scroll position when popover is opened
    if (this.state.diagnosesAndExtremitiesViewName !== prevState.diagnosesAndExtremitiesViewName && 
        this.state.diagnosesAndExtremitiesViewName !== "") {
      const popoverElement = this.popoverRefs.get(this.state.diagnosesAndExtremitiesViewName);
      if (popoverElement) {
        popoverElement.scrollTop = 0;
      }
    }
  }

  // getStatusofCompleteDisabilities = (patient) => {
  //   let signedDbqs = []
  //   let signedLocalDbqs = localStorage.getItem('signedDbqs') ? JSON.parse(localStorage.getItem('signedDbqs')): '';
  //   signedLocalDbqs && signedLocalDbqs.forEach(function (signedDbqObj) {
  //       if (signedDbqObj.patientId === patient.id) {
  //         signedDbqs = signedDbqObj.signedDbq.split(",")
  //       }
  //   });
  //   return signedDbqs.length;
  // }

  showDisabilitiesByDbStatus = (appointment) => {
    let patient = appointment.patient;
    let alreadySignedDbqs = [];
    // let signedLocalDbqs = localStorage.getItem('signedDbqs') ? JSON.parse(localStorage.getItem('signedDbqs')): '';
    // signedLocalDbqs && signedLocalDbqs.forEach(function (signedDbqObj) {
    //   if (signedDbqObj.patientId === patient.id) {
    //       alreadySignedDbqs = signedDbqObj.signedDbq.split("#")
    //       alreadySignedDbqs = _.uniq(alreadySignedDbqs)
    //       console.log("alreadySignedDbqs", alreadySignedDbqs)
    //   }
    // })

    let signedDbq = sessionStorage.getItem("signedDbq")
      ? JSON.parse(sessionStorage.getItem("signedDbq"))
      : "";
    let signedDbqId = signedDbq && signedDbq.id ? signedDbq.id : "";
    let time =
      signedDbq &&
      signedDbq.time &&
      (new Date().getTime() - signedDbq.time) / 1000 < 120
        ? true
        : false;
    let disabilities = appointment.disabilities;
    let keyPatient = 0;
    let disabilitiesStatuses = [];
    let disabilitiesCompnent = [];
    let signedDisabilitiesCompnent = [];

    _.forEach(disabilities.records, (disbaility) => {
      // let isDbqAlreadySigned = alreadySignedDbqs.includes(disbaility.name.toLowerCase());
      // if(disbaility.isSigned || isDbqAlreadySigned) {
      if (disbaility.isSigned || (disbaility.id === signedDbqId && time)) {
        signedDisabilitiesCompnent.push(
          <span
            key={"spanFirst" + disbaility.name + keyPatient++}
            className="dashboard-dbq-icon-caption"
          >
            <span
              onClick={
                disbaility.status_c === "Unable to Examine"
                  ? undefined
                  : this.submitClick.bind(
                      this,
                      `/admin/exam`,
                      appointment,
                      disbaility.id,
                      disbaility.name,
                      disbaility.name_fv,
                      disabilities.records.length,
                      disbaility.isSigned,
                      disbaility.diagnosesAndExtremities
                    )
              }
              className="disabality-name-tooltip"
            >
              <span className="disabality-name-tooltip">
                <img
                  style={
                    disbaility.status_c === "Unable to Examine"
                      ? { filter: "grayscale(1)" }
                      : { cursor: "unset" }
                  }
                  className="dashboard-dbq disabality-name-tooltip dashboard-dbq-img-width"
                  key={disbaility.name + keyPatient++}
                  title={disbaility.name}
                  src={
                    "/imgs/app/vbg-icons-green/" +
                    disbaility.name_fv.toLowerCase() +
                    ".png"
                  }
                  alt={disbaility.name + " image"}
                ></img>
                {/* <span className="disabality-name-tooltip-text">
                  {disbaility.name}{" "}
                </span> */}
              </span>
            </span>
            <span
              style={{ display: "block" }}
              ref={this.setDiagnosesAndExtremitiesRef}
            >
              {disbaility.name_fv}{" "}
              {disbaility.diagnosesAndExtremities &&
                disbaility.diagnosesAndExtremities.length !== 0 && (
                  <span style={{ position: "relative" }}>
                    <sup>
                      <img
                        src="/imgs/app/info-circle.svg"
                        alt="More info"
                        width="18"
                        height="18"
                        style={{ cursor: "pointer" }}
                        onClick={this.handleDiagnosesAndExtremitiesView.bind(
                          this,
                          disbaility.id
                        )}
                        id={`diagnosesAndExtremities-${disbaility.id}`}
                      />
                    </sup>
                    <span
                      className="diagnoses-extremities-popup custom-scrollbar"
                      ref={(node) => this.setPopoverRef(disbaility.id, node)}
                      style={{
                        display:
                          this.state.diagnosesAndExtremitiesViewName ===
                          disbaility.id
                            ? "inline"
                            : "none",
                      }}
                    >                 
                      {disbaility.diagnosesAndExtremities.length !== 0 ? (
                        disbaility.diagnosesAndExtremities.map(
                          (moreInfo, index) => (
                            <span key={moreInfo.diagnosis + index}>
                              <p>Diagnosis: {moreInfo.diagnosis}</p>
                              {moreInfo.extremity && (
                                <p>Extremity: {moreInfo.extremity}</p>
                              )}
                              {moreInfo.icdCode && (
                                <p>ICD Code: {moreInfo.icdCode}</p>
                              )}
                              {disbaility.diagnosesAndExtremities.length - 1 !== index && (
                                <br />
                              )}
                            </span>
                          )
                        )
                      ) : (
                        <p>Not available</p>
                      )}
                    </span>
                  </span>
                )}
            </span>
          </span>
        );
      } else {
        disabilitiesCompnent.push(
          <span
            key={"spanSecond" + disbaility.name + keyPatient++}
            className="dashboard-dbq-icon-caption"
          >
            <span
              onClick={
                disbaility.status_c === "Unable to Examine"
                  ? undefined
                  : this.submitClick.bind(
                      this,
                      `/admin/exam`,
                      appointment,
                      disbaility.id,
                      disbaility.name,
                      disbaility.name_fv,
                      disabilities.records.length,
                      disbaility.isSigned,
                      disbaility.diagnosesAndExtremities
                    )
              }
              className="disabality-name-tooltip"
            >
              <img
                className={
                  disbaility.status_c === "Unable to Examine"
                    ? "disabality-name-tooltip dashboard-dbq-img-width"
                    : "dashboard-dbq disabality-name-tooltip dashboard-dbq-img-width"
                }
                key={disbaility.name + keyPatient++}
                title={disbaility.name}
                src={
                  "/imgs/app/vbg-icons/" +
                  disbaility.name_fv.toLowerCase() +
                  ".png"
                }
                alt={disbaility.name + " image"}
                style={
                  disbaility.status_c === "Unable to Examine"
                    ? { filter: "grayscale(1)" }
                    : {}
                }
              ></img>
              <span className="disabality-name-tooltip-text">
                {disbaility.name}
              </span>
            </span>
            <span
              style={{ display: "block" }}
              ref={this.setDiagnosesAndExtremitiesRef}
            >
              {disbaility.name_fv}{" "}
              {disbaility.diagnosesAndExtremities && (
                <span style={{ position: "relative" }}>
                  <sup>
                    <img
                      src="/imgs/app/info-circle.svg"
                      alt="More info"
                      width="18"
                      height="18"
                      style={{ cursor: "pointer" }}
                      onClick={this.handleDiagnosesAndExtremitiesView.bind(
                        this,
                        disbaility.id
                      )}
                      id={`diagnosesAndExtremities-${disbaility.id}`}
                    />
                  </sup>
                  <span
                    className="diagnoses-extremities-popup custom-scrollbar"
                    ref={(node) => this.setPopoverRef(disbaility.id, node)}
                    style={{
                      display:
                        this.state.diagnosesAndExtremitiesViewName ===
                        disbaility.id
                          ? "inline"
                          : "none",
                    }}
                  >
                    {disbaility.diagnosesAndExtremities.length !== 0 ? (
                      disbaility.diagnosesAndExtremities.map(
                        (moreInfo, index) => (
                          <span key={moreInfo.diagnosis + index}>
                            <p>Diagnosis: {moreInfo.diagnosis}</p>
                            {moreInfo.extremity && (
                              <p>Extremity: {moreInfo.extremity}</p>
                            )}
                            {moreInfo.icdCode && (
                              <p>ICD Code: {moreInfo.icdCode}</p>
                            )}
                            {disbaility.diagnosesAndExtremities.length - 1 !== index && (
                              <br />
                            )}
                          </span>
                        )
                      )
                    ) : (
                      <p>Not available</p>
                    )}
                  </span>
                </span>
              )}
            </span>
          </span>
        );
      }
    });
    disabilitiesStatuses = _.union(
      signedDisabilitiesCompnent,
      disabilitiesCompnent
    );
    // disabilitiesStatuses.push(
    //   <span key="add_new_dbq" className="dashboard-dbq-icon-caption">
    //     <span  className='disabality-name-tooltip'>
    //       {/* <img className='dashboard-dbq disabality-name-tooltip dashboard-dbq-img-width'
    //         key="add_new" title="Add_New"
    //         src='/imgs/app/add_dbq.png'
    //         alt='Add New image'
    //         style={{width: '65px'}}
    //         >
    //       </img> */}
    //       <div className='dashboard-dbq disabality-name-tooltip dashboard-dbq-img-width' style={{border: '2px solid #079EDA', borderRadius: '50%', width: '70px', height: '70px', position: 'relative', paddingTop: 18, paddingLeft: 3, marginBottom: 10}}>
    //       <Icon glyph='glyphicon glyphicon-plus' style={{fontSize: '1.7em', color: '#079EDA'}}/>
    //       </div>
    //       <span className='disabality-name-tooltip-text'>DBQ</span>
    //     </span>
    //       <span style={{display: 'block'}}>Add DBQ</span>
    //   </span>
    //   )
    return disabilitiesStatuses;
  };

  showDisabilities = (disabilities) => {
    let disabilitiesCompnent = [];
    let keyPatient = 0;
    if (disabilities && disabilities.records && disabilities.records.length) {
      _.forEach(disabilities.records, (disbaility) => {
        // disabilitiesCompnent.push(<span key={disbaility.name + keyPatient++} className="comma">{disbaility.name}&nbsp;</span>)
        disabilitiesCompnent.push(
          <span className="disabality-name-tooltip">
            <img
              className="dashboard-dbq disabality-name-tooltip"
              style={{ marginRight: "-20px" }}
              key={disbaility.name + keyPatient++}
              title={disbaility.name}
              src={
                "/imgs/app/vbg-icons/" + disbaility.name.toLowerCase() + ".png"
              }
              width="80px"
              alt={disbaility.name + " image"}
            ></img>{" "}
            <span className="disabality-name-tooltip-text">
              {disbaility.name}{" "}
            </span>
          </span>
        );
      });
    }
    return disabilitiesCompnent;
  };

  actions = (link, patient) => {
    const { history } = this.props;
    this.props.routeChange();
    history.push({ pathname: link, state: patient });
  };

  submitClick = (
    link,
    appointment,
    disabalityId,
    disabilityName,
    name_fv,
    dbqCount,
    dbqStatusLoaded,
    diagnosesAndExtremities
  ) => {
    sessionStorage.setItem(
      "currentDiagnosesAndExtremities",
      diagnosesAndExtremities && diagnosesAndExtremities.length !== 0
        ? JSON.stringify(diagnosesAndExtremities)
        : null
    );
    console.log("dbqStatusLoaded dbqStatusLoaded =>", dbqStatusLoaded);
    let patient = appointment.patient;
    let patientDisabilities = [];
    if (appointment.disabilities.records) {
      for (let i = 0; i < appointment.disabilities.records.length; i++) {
        patientDisabilities.push({
          dbqId: appointment.disabilities.records[i].id,
          name: appointment.disabilities.records[i].name,
          name_fv: appointment.disabilities.records[i].name_fv,
          isSigned: appointment.disabilities.records[i].isSigned,
          dbqCondition: appointment.disabilities.records[i].condition_c,
          status_c: appointment.disabilities.records[i].status_c,
          diagnosesAndExtremities:
            appointment.disabilities.records[i].diagnosesAndExtremities,
        });
      }
    }
    const { history } = this.props;
    let patientProp = {
      id: patient.id,
      name: patient.name,
      apptDate: appointment.appt_date_text_c,
      birthdate: patient.birthdate,
      ssn_encrypt_c: patient.ssn_encrypt_c,
      dbqCount: dbqCount,
      apptId: appointment.id,
      apptTime: appointment.appt_time_text_c,
      disabilities: patientDisabilities,
      doctorsInfo: appointment.doctorsInfo,
      ssn: null,
      itfExpire: patient.itfexpires_c,
    };
    sessionStorage.setItem("patient", JSON.stringify(patientProp));

    let currentDbqProp = {
      name: disabilityName,
      name_fv: name_fv,
      id: disabalityId,
    };
    sessionStorage.setItem("currentDbq", JSON.stringify(currentDbqProp));

    sessionStorage.setItem("page", "home");
    sessionStorage.removeItem("signedDbq");
    this.props.getPatientDoc(
      patient && patient.id,
      disabilityName,
      disabalityId
    );

    // checking if there is already an incomplete exam in DB
    let token = localStorage.getItem("login_token");
    let headers = { "Content-Type": "application/json" };
    headers["Authorization"] = `Bearer ${token}`;
    let obj = {
      pId: patient && patient.id ? patient.id : "",
      dbqId: disabalityId,
      appointmentId: appointment.id,
    };
    
    fetch(process.env.API_URL + "/dbq/exam", {
      method: "post",
      headers,
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.questions && data.questions.length > 0) {
          patientProp.ssn = data.ssn;
          patientProp.isPreviousVersion = data.isPreviousVersion;
          //this.setState({showExamResumeOrNew: true, questionsFromDb: data.questions, dbqStatusInDb: data.status, currentDbq:currentDbqProp, patient:patientProp, link})
          this.setState({
            showExamEmailOrNew: dbqStatusLoaded,
            showExamResumeOrNew: !dbqStatusLoaded,
            dbqIsSigned: dbqStatusLoaded,
            questionsFromDb: data.questions,
            dbqStatusInDb: data.status,
            currentDbq: currentDbqProp,
            patient: patientProp,
            link,
          });
        } else {
          console.log("Did not find Incomplete exam");
          sessionStorage.setItem("questionState", null);
          sessionStorage.removeItem("page");
          this.loadExamQuestions(
            disabalityId,
            disabilityName,
            name_fv,
            link,
            patientProp
          );
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadExamQuestions = (
    disabalityId,
    disabilityName,
    name_fv,
    link,
    patient
  ) => {
    const { history } = this.props;
    this.setState({ loadingExam: true });
    let token = localStorage.getItem("login_token");
    let headers = { "Content-Type": "application/json" };
    headers["Authorization"] = `Bearer ${token}`;
    fetch(
      process.env.API_URL +
        "/patients/version/" +
        disabalityId +
        "/" +
        disabilityName,
      { headers }
    )
      .then((response) => response.json())
      .then((data) => {
        //if (data.questions && data.questions.length>0) {
        let newQues = data.questions;
        sessionStorage.setItem("questionState", JSON.stringify(newQues));
        sessionStorage.setItem("page", "home");
        let currentDbqProp = {
          name: disabilityName,
          name_fv: name_fv,
          id: disabalityId,
          src: data.src,
        };
        sessionStorage.setItem("currentDbq", JSON.stringify(currentDbqProp));
        patient.ssn = data.ssn;
        patient.isPreviousVersion = data.isPreviousVersion;
        sessionStorage.setItem("patient", JSON.stringify(patient));
        this.setState({ loadingExam: false, patient: patient });
        history.push({
          pathname: link,
          currentDbq: currentDbqProp,
          questionState: newQues,
          patient,
          page: "home",
          src: data.src,
        });
        // } else {
        //   alert(data.msg)
        // }
      })
      .catch((error) => {
        this.setState({ loadingExam: false });
        console.error("Error:", error);
      });
  };

  showUnableToExamModal = (appt) => {
    let newAppt = JSON.parse(JSON.stringify(appt));
    let records = [];
    if (newAppt && newAppt.disabilities && newAppt.disabilities.records) {
      records = _.filter(newAppt.disabilities.records, function (o) {
        return !o.isSigned;
      });
    }
    newAppt.disabilities.records = records;
    this.setState({ appt: newAppt, showUnableToExam: true });
  };
  closeUnableToExamModal = () => {
    this.setState({ showUnableToExam: false });
  };
  showPopOver = (e, index) => {
    e.stopPropagation();
    this.setState({ selected_row_index: index });
  };

  closePopOver = () => {
    this.setState({ selected_row_index: null });
  };

  loadPatients = () => {
    sessionStorage.removeItem("questionState");

    let { allPatients = undefined } = this.props;
    let appointments = allPatients.appointments;
    let component = [];
    if (allPatients && appointments && appointments.length) {
      _.sortBy(appointments, "appt_time_text_c").map((appt, index) =>
        component.push(
          <div
            className="show-with-ease"
            key={"patientRecord" + appt.id}
            style={{ marginLeft: -20 }}
          >
            <PanelContainer
              key={"patientRecordPanel" + appt.id}
              className="vbg-card-shadow"
            >
              <Panel
                className="mt-20"
                style={{ paddingTop: 20, paddingBottom: 20 }}
              >
                <Row
                  className="fg-black vertical-middle"
                  style={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  <Col
                    xs={3}
                    sm={3}
                    md={3}
                    className="dashboard-name-font-size"
                    smCollapseRight
                  >
                    {" "}
                    <div>{appt.patient.name}</div>{" "}
                    <div className="dashboard-ssn-dob">
                      <div style={{ marginBottom: "-5px" }}>
                        DOB:{" "}
                        {appt.patient.birthdate
                          ? moment(appt.patient.birthdate).format(
                              DEFAULT_DATE_FORMAT
                            )
                          : "N/A"}
                      </div>{" "}
                      <div>
                        SSN:{" "}
                        {getScretSSN(0, "XXX-XX", appt.patient.ssn_encrypt_c)}
                      </div>
                    </div>
                  </Col>
                  {/* <Col xs={3} sm={3} md={3}  smCollapseRight> {this.showDisabilities(patient.disabilities)}</Col> */}
                  <Col xs={7} sm={6} md={7} smCollapseRight>
                    {" "}
                    {this.showDisabilitiesByDbStatus(appt)}
                  </Col>
                  <Col
                    xs={2}
                    sm={3}
                    md={2}
                    className="dashboard-time-font-size margin-left-apt-time"
                    smCollapseRight
                    style={{ marginTop: -20 }}
                  >
                    {/* {moment(patient.fbsg_appt_time_date_c).format(DEFAULT_DATE_FORMAT)}
                    <br /> */}
                    <div style={{ marginRight: 25, textAlign: "right" }}>
                      <span
                        className="dashboard-three-dots"
                        onClick={(e) => {
                          this.showPopOver(e, index);
                        }}
                      >
                        <Icon
                          glyph="glyphicon glyphicon-option-horizontal"
                          style={{ fontSize: "0.8em" }}
                        />
                      </span>
                      <div
                        className="popover__wrapper"
                        style={{ fontSize: 16, textAlign: "left", width: 30 }}
                      >
                        <div
                          className={
                            this.state.selected_row_index !== index
                              ? "popover__before"
                              : "popover__after"
                          }
                          style={{ width: 190 }}
                        >
                          <div
                            className="popover__menu"
                            onClick={(e) => {
                              this.showUnableToExamModal(appt);
                            }}
                            style={{ color: "#f12f39", fontWeight: "bold" }}
                          >
                            Unable to Examine
                          </div>
                          {/* <div className="popover__menu" >Reset Password</div> */}
                          <div
                            className="popover__menu"
                            onClick={(e) => {
                              this.closePopOver();
                            }}
                          >
                            Cancel
                          </div>
                        </div>
                      </div>
                    </div>
                    {moment(appt.appt_time_text_c, "hh:mm").format("LT")}
                  </Col>
                  {/* <Col>
                    <div>
                        <span key={appt.id} style={{fontSize: '18px', fontWeight: '900', cursor: 'pointer', verticalAlign: 'super'}} onClick={e => this.showPopOver(e)}>...</span>
                        <div className='popover__wrapper'>
                            <div className={!this.state.showPopOverFlag ? 'popover__before': 'popover__after'}>
                                <div className="popover__menu" >Edit</div>
                                <div className="popover__menu" >Reset Password</div>
                                <div className="popover__menu" >Delete</div>
                            </div>
                        </div>
                    </div>
                  </Col> */}

                  {/* <Col xs={3} sm={3} md={3} smCollapseRight>
                    <table>
                      <tr>
                        <td colSpan={5} >{this.getStatusofCompleteDisabilities(patient)}/{patient.disabilities && patient.disabilities.records ? patient.disabilities.records.length : 0} Complete</td>
                      </tr>
                      <tr>
                        {this.showStatusOfDisabilities(patient)}
                      </tr>
                      </table>
                  </Col> */}

                  {/* <Col xs={1} sm={1} md={1} smCollapseRight style={{marginTop: '8px'}}>
                    <Button
                      type='button'
                      bsStyle='primary'
                      className="btn"
                      style={{background: '#022144', color: 'white', width: '50px', height: '50px', borderRadius: '10px', border: '1px solid #022144', boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.25)'}}
                      onClick={this.actions.bind(this, `/admin/confirmPatient`, patient)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" viewBox="0 0 24 24" fill='#fff' style={{marginTop: '4px'}}><path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"/></svg>
                    </Button>
                  </Col> */}
                </Row>
              </Panel>
            </PanelContainer>
          </div>
        )
      );
    } else {
      component.push(
        <div key={"patientRecordNoRecord"} style={{ marginLeft: -20 }}>
          <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
            <Panel
              className="mt-20"
              style={{ paddingTop: 20, paddingBottom: 20 }}
            >
              <Row
                className="fg-black vertical-middle"
                style={{ fontWeight: "bold", fontSize: "16px" }}
              >
                <Col
                  className="font-weight-600 table-th-font-size"
                  xs={12}
                  sm={12}
                  md={12}
                  smCollapseRight
                >
                  <div
                    key={`no-patients`}
                    style={{ width: "100%", textAlign: "left", marginTop: 10 }}
                  >
                    <div
                      className="patient-main-text"
                      style={{ width: "100%", textAlign: "center" }}
                    >
                      No Patient to show
                    </div>
                  </div>
                </Col>
              </Row>
            </Panel>
          </PanelContainer>
        </div>
      );
    }
    return component;
  };

  renderLoadingState = (stateFor) => {
    return (
      <div key={"patientRecordLoading"} style={{ marginLeft: -20 }}>
        <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
          <Panel
            className="mt-20"
            style={{ paddingTop: 20, paddingBottom: 20 }}
          >
            <Row
              className="fg-black vertical-middle"
              style={{ fontWeight: "bold", fontSize: "16px" }}
            >
              <Col
                className="font-weight-600 table-th-font-size"
                xs={12}
                sm={12}
                md={12}
                smCollapseRight
              >
                <div
                  style={{ width: "100%", textAlign: "left", marginTop: 10 }}
                >
                  <div
                    className="patient-main-text"
                    style={{ width: "100%", textAlign: "center" }}
                  >
                    Loading {stateFor}...
                  </div>
                </div>
              </Col>
            </Row>
          </Panel>
        </PanelContainer>
      </div>
    );
  };
  closeShowExamNew = (e) => {
    let { questionsFromDb, currentDbq, patient, link } = this.state;
    const { history } = this.props;
    if (e.param === "exam" && e.src === "second") {
      sessionStorage.setItem("questionState", JSON.stringify(questionsFromDb));
      sessionStorage.setItem("patient", JSON.stringify(patient));
      sessionStorage.setItem("examIsResumed", true);
      console.log("Resumed exam in DB");
      history.push({
        pathname: link,
        currentDbq: currentDbq,
        questionState: questionsFromDb,
        patient: patient,
        page: "home",
      });
    } else if (
      (e.param === "exam" && e.src === "first") ||
      (e.param === "sign" && e.src === "second")
    ) {
      console.log("Start over new exam");
      sessionStorage.setItem("questionState", null);
      sessionStorage.removeItem("page");
      //history.push({pathname:link, currentDbq:currentDbq, questionState: null, patient:patient, page: "home"})
      this.loadExamQuestions(
        currentDbq.id,
        currentDbq.name,
        currentDbq.name_fv,
        link,
        patient
      );
    }
    this.setState({ showExamResumeOrNew: false });
  };

  closeShowExamEmailOrNew = (e) => {
    if (e.input === "email") {
      this.emailExam();
    } else if (e.input === "new") {
      this.setState({ showExamResumeOrNew: true });
    } else {
      this.setState({ showExamEmailOrNew: false });
    }
  };

  emailExam = () => {
    if (this.state && this.state.currentDbq && this.state.currentDbq.id) {
      // this.setState({loadingExam: true})
      this.props && this.props.onEmailSent();
      let token = localStorage.getItem("login_token");
      let headers = { "Content-Type": "application/json" };
      headers["Authorization"] = `Bearer ${token}`;
      fetch(
        process.env.API_URL + "/patients/email/" + this.state.currentDbq.id,
        { headers }
      )
        .then((response) => response.json())
        .then((data) => {
          this.setState({ loadingExam: false });
        })
        .catch((error) => {
          console.error("Error:", error);
          // this.setState({loadingExam: false})
        });
    }
  };

  loadMorePatients = (pageNumber) => {
    const startDate = this.props.startDate;

    this.props.getAllCampaignPatients(pageNumber, startDate);
  };
  render() {
    const {
      fetchingPatients,
      allPatients = undefined,
      pageNumber = 1,
      pageSize,
      allPatientsCount = 0,
      onChangeValue,
    } = this.props;

    !fetchingPatients &&
      onChangeValue({
        totalPatients: allPatients.totalPatients,
        totalDBQ: allPatients.totalDBQ,
      });
    return (
      <Row
        onClick={(e) => {
          this.closePopOver();
        }}
      >
        <div ref={this.setWrapperRef}>
          {this.props.children}
          <Col xs={12} sm={12}>
            {this.state.showExamEmailOrNew && (
              <ExamEmailOrNew
                status={this.state.dbqIsSigned}
                onClose={this.closeShowExamEmailOrNew}
              />
            )}
            {this.state.showExamResumeOrNew && (
              <ExamResumeOrNew
                status={this.state.dbqIsSigned}
                onClose={this.closeShowExamNew}
              />
            )}
            {this.state.showUnableToExam && (
              <UnableToExamModal
                appt={this.state.appt}
                onClose={this.closeUnableToExamModal}
              />
            )}
            {this.state.loadingExam && <LoadingContainer />}
            <Grid>
              <div style={{ marginTop: 10 }}>
                <Row>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ marginTop: -5 }}
                    smCollapseRight
                  >
                    <Row>
                      <Col
                        className="font-weight-600 table-th-font-size"
                        xs={3}
                        sm={3}
                        md={3}
                        style={{
                          marginTop: -5,
                          textAlign: "center",
                          color: "#022144",
                        }}
                        smCollapseRight
                      >
                        Patient name
                      </Col>
                      <Col
                        className="font-weight-600 table-th-font-size"
                        xs={7}
                        sm={7}
                        md={7}
                        style={{
                          marginTop: -5,
                          textAlign: "center",
                          color: "#022144",
                        }}
                        smCollapseRight
                      >
                        DBQs
                      </Col>
                      <Col
                        className="font-weight-600 table-th-font-size"
                        xs={1}
                        sm={1}
                        md={1}
                        style={{ marginTop: -5, color: "#022144" }}
                        smCollapseRight
                      >
                        Time
                      </Col>
                      {/* <Col className='font-weight-600 table-th-font-size' xs={3} sm={3} md={3} style={{marginTop: -5}} smCollapseRight>Status</Col> */}
                      {/* <Col className='font-weight-600 table-th-font-size' xs={1} sm={1} md={1} style={{marginTop: -5}} smCollapseRight>Begin</Col> */}
                    </Row>
                    <div>
                      {!fetchingPatients
                        ? this.loadPatients()
                        : this.renderLoadingState("Patients")}
                    </div>
                  </Col>
                </Row>
                {pageNumber && allPatientsCount > 10 ? (
                  <Grid>
                    <Row>
                      <Col xs={12} style={{ paddingTop: 12.5 }}>
                        <h3 className="text-center">
                          <Pagination
                            prev
                            next
                            first
                            last
                            ellipsis
                            boundaryLinks
                            bsSize="large"
                            maxButtons={4}
                            items={Math.ceil(allPatientsCount / pageSize)}
                            activePage={parseInt(pageNumber)}
                            onSelect={this.loadMorePatients}
                          />
                        </h3>
                      </Col>
                    </Row>
                  </Grid>
                ) : null}
              </div>
            </Grid>
          </Col>
        </div>
      </Row>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getAllCampaignPatients: (pageNumber, startDate) => {
    dispatch(PatientActions.getAllPatientsRequest(pageNumber, startDate));
  },
  getPatientDoc: (id, dbq, dbqId) => {
    dispatch(
      PatientActions.getSpecificPatientDocumentRequest({
        id,
        dbq,
        dbqId,
      })
    );
  },
});

const mapStateToProps = ({
  fetching,
  patient: {
    all: {
      pageNumber = 1,
      pageSize = 10,
      allPatientsCount,
      allPatients = [],
      error: patientError = undefined,
      fetching: fetchingPatients = false,
    },
  },
}) => {
  return {
    fetching,
    allPatients,
    fetchingPatients,
    pageNumber,
    pageSize,
    allPatientsCount,
    patientError,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WidgetBlocks);
